/**
 * Utility functions for AI Generator
 */

import { SDXL_STYLE_MAP, SDXL_LIGHTING_MAP } from './constants';

/**
 * Build final prompt with style mapping
 */
export const buildFinalPrompt = (prompt: string): string => {
  const cleanPrompt = prompt.replace(/'/g, ""); // Remove apostrophes to prevent API errors
  return cleanPrompt.trim();
};

/**
 * Map Runway parameters to SDXL format
 */
export const mapToSDXLParams = (
  runwayPrompt: string,
  selectedImageStyle?: string,
  selectedLighting?: string,
  enhanceDetails?: boolean,
  colorBoost?: boolean,
  improveComposition?: boolean
): string => {
  let sdxlPrompt = runwayPrompt;
  
  // Append style information to prompt for SDXL
  if (selectedImageStyle && SDXL_STYLE_MAP[selectedImageStyle]) {
    sdxlPrompt += `, ${SDXL_STYLE_MAP[selectedImageStyle]}`;
  }

  if (selectedLighting && SDXL_LIGHTING_MAP[selectedLighting]) {
    sdxlPrompt += `, ${SDXL_LIGHTING_MAP[selectedLighting]}`;
  }

  // Additional enhancements
  if (enhanceDetails) sdxlPrompt += ', highly detailed';
  if (colorBoost) sdxlPrompt += ', vibrant colors';
  if (improveComposition) sdxlPrompt += ', perfect composition';

  return sdxlPrompt;
};

/**
 * Get SDXL quality settings from Runway quality selection
 */
export const getSDXLQualitySettings = (selectedImageQuality: string) => {
  const qualityMap = {
    'draft': { steps: 30, guidance_scale: 7.0 },
    'standard': { steps: 50, guidance_scale: 7.5 },
    'high': { steps: 70, guidance_scale: 8.0 },
    'ultra': { steps: 100, guidance_scale: 8.5 }
  };
  return qualityMap[selectedImageQuality] || qualityMap['standard'];
};

/**
 * Get dimensions for selected aspect ratio
 */
export const getDimensionsForRatio = (aspectRatio: string) => {
  const ratioMap = {
    '16:9': { width: 1536, height: 864 },
    '9:16': { width: 864, height: 1536 },
    '1:1': { width: 1024, height: 1024 }
  };
  return ratioMap[aspectRatio] || ratioMap['16:9'];
};

/**
 * Get quality settings based on selected quality
 */
export const getQualitySettings = (selectedQuality: string) => {
  const qualityMap = {
    'standard': { 
      use_refiner: false, 
      steps: 40, 
      guidance_scale: 7.5 
    },
    'high': { 
      use_refiner: true, 
      steps: 60, 
      refiner_steps: 20, 
      guidance_scale: 8.0 
    },
    'professional': { 
      use_refiner: true, 
      steps: 80, 
      refiner_steps: 20, 
      guidance_scale: 8.5 
    }
  };
  return qualityMap[selectedQuality] || qualityMap['standard'];
};
